// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play__scores {
  display: flex;
  align-items: stretch;
  min-width: 0;
  padding: 2px var(--pad) 4px;
}
.play__scores .stat {
  flex: 1 1 0;
  min-width: 0;
  text-align: center;
  padding: 6px 4px;
}
.play__scores .stat + .stat {
  border-left: 1px solid var(--palette-border);
}
.stat__label {
  font-size: 0.64rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
}
.stat__val {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.1;
  margin-top: 2px;
}
.stat--time .stat__val {
  color: var(--palette-primary);
}

/* Found words: single line, newest on the left, flowing off the right edge.
   Fixed height so the board never shrinks when the first word appears. */
.play__found {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 44px;
  height: 44px;
  min-width: 0;
  padding: 0 0 0 var(--pad);
  overflow: hidden;
  white-space: nowrap;
  -webkit-mask-image: linear-gradient(to right, #000 78%, transparent);
  mask-image: linear-gradient(to right, #000 78%, transparent);
}
.play__found .word {
  flex: 0 0 auto;
  line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/scorePanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oEAAoE;EACpE,4DAA4D;AAC9D;AACA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".play__scores {\n  display: flex;\n  align-items: stretch;\n  min-width: 0;\n  padding: 2px var(--pad) 4px;\n}\n.play__scores .stat {\n  flex: 1 1 0;\n  min-width: 0;\n  text-align: center;\n  padding: 6px 4px;\n}\n.play__scores .stat + .stat {\n  border-left: 1px solid var(--palette-border);\n}\n.stat__label {\n  font-size: 0.64rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n}\n.stat__val {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 1.1;\n  margin-top: 2px;\n}\n.stat--time .stat__val {\n  color: var(--palette-primary);\n}\n\n/* Found words: single line, newest on the left, flowing off the right edge.\n   Fixed height so the board never shrinks when the first word appears. */\n.play__found {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 44px;\n  height: 44px;\n  min-width: 0;\n  padding: 0 0 0 var(--pad);\n  overflow: hidden;\n  white-space: nowrap;\n  -webkit-mask-image: linear-gradient(to right, #000 78%, transparent);\n  mask-image: linear-gradient(to right, #000 78%, transparent);\n}\n.play__found .word {\n  flex: 0 0 auto;\n  line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
